export const darkColorTokens = {
    OV: {
        sys: {
            surfaceDim: '#101415',
            surfaceBright: '#363a3a',
            surfaceContainerLowest: '#1a1d21',
            surfaceContainerLow: '#191c1d',
            surfaceContainer: '#1d2021',
            surfaceContainerHigh: '#272b2b',
            surfaceContainerHighest: '#323536',
            scrim: '#000000',
            outlineVariant: '#3f484a',
            surfaceTint: '#00696c',
            shadow: '#000000',
            inversePrimary: '#00696c',
            inverseOnSurface: '#191c1d',
            inverseSurface: '#e1e3e3',
            onSurfaceVariant: '#bec8ca',
            surfaceVariant: '#3f484a',
            onSurface: '#c4c7c7',
            surface: '#101415',
            onBackground: '#e1e3e3',
            background: '#191c1d',
            outline: '#899294',
            onErrorContainer: '#ffdad6',
            errorContainer: '#93000d',
            onError: '#690006',
            error: '#ffb4ac',
            onTertiaryFixedVariant: '#004a7a',
            tertiaryFixedDim: '#9bcbff',
            onTertiaryFixed: '#001d34',
            tertiaryFixed: '#d0e4ff',
            onTertiaryContainer: '#d0e4ff',
            tertiaryContainer: '#004a7a',
            onTertiary: '#003256',
            tertiary: '#9bcbff',
            onSecondaryFixedVariant: '#6300bb',
            secondaryFixedDim: '#d8b9ff',
            onSecondaryFixed: '#290055',
            secondaryFixed: '#eedcff',
            onSecondaryContainer: '#eedcff',
            secondaryContainer: '#6300bb',
            onSecondary: '#450086',
            secondary: '#d8b9ff',
            onPrimaryFixedVariant: '#004f51',
            primaryFixedDim: '#4adade',
            onPrimaryFixed: '#002021',
            primaryFixed: '#6df6fa',
            onPrimaryContainer: '#6df6fa',
            primaryContainer: '#004f51',
            onPrimary: '#003738',
            primary: '#4adade',
            success: '#00c853',
            successContainer: '#357a38',
            onSuccessContainer: '#ffffff',
        },
        extended: {
            Essentials: {
                color: '#6bdbad',
                onColor: '#003826',
                colorContainer: '#005139',
                onColorContainer: '#88f8c8',
            },
            Priority: {
                color: '#ffb3b1',
                onColor: '#640a15',
                colorContainer: '#842328',
                onColorContainer: '#ffdad8',
            },
            Proactive: {
                color: '#d2bcff',
                onColor: '#3e008f',
                colorContainer: '#5900c7',
                onColorContainer: '#eaddff',
            },
            Signature: {
                color: '#ffb94e',
                onColor: '#452b00',
                colorContainer: '#624000',
                onColorContainer: '#ffddb2',
            },
        },
    },
};
